import React from 'react';
import { ArrowRight, Phone, Mail, MessageCircle, Heart } from 'lucide-react';

export default function FinalCTA() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 p-10 md:p-14 text-center">
            <div className="absolute inset-0 opacity-20 pointer-events-none">
              <div className="absolute top-0 left-0 w-72 h-72 bg-white/20 rounded-full blur-3xl" />
              <div className="absolute bottom-0 right-0 w-72 h-72 bg-white/20 rounded-full blur-3xl" />
            </div>
            <div className="relative">
              <h2 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight">
                Ready to Transform Your Preparation?
              </h2>
              <p className="mt-4 text-white/90 text-lg">
                Join 50,000+ students who are already crushing their exams with Mind to Master
              </p>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
                <button
                  onClick={() => scrollTo('#pricing')}
                  className="inline-flex items-center gap-2 bg-white text-emerald-600 hover:bg-slate-100 font-semibold px-6 py-3 rounded-md transition-colors shadow-lg"
                >
                  Get Started for ₹499 <ArrowRight size={18} />
                </button>
                <button
                  onClick={() => scrollTo('#pricing')}
                  className="inline-flex items-center gap-2 border-2 border-white/70 text-white hover:bg-white/10 font-semibold px-6 py-3 rounded-md transition-colors"
                >
                  View All Plans
                </button>
              </div>
              <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-white/90 text-sm">
                <span>✓ No credit card required</span>
                <span>•</span>
                <span>✓ 7-day money-back guarantee</span>
                <span>•</span>
                <span>✓ Cancel anytime</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="pt-10 pb-8 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-emerald-400 font-bold text-xl">Mind to Master</h3>
              <p className="mt-3 text-slate-400">India&apos;s most advanced test series platform for government exam preparation.</p>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm text-slate-400">
                <li><a href="#features" className="hover:text-emerald-400 transition-colors">Features</a></li>
                <li><a href="#pricing" className="hover:text-emerald-400 transition-colors">Pricing</a></li>
                <li><a href="#reviews" className="hover:text-emerald-400 transition-colors">Reviews</a></li>
                <li><a href="#faq" className="hover:text-emerald-400 transition-colors">FAQ</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Popular Exams</h4>
              <ul className="space-y-2 text-sm text-slate-400">
                <li><a href="#" className="hover:text-emerald-400 transition-colors">SSC CGL</a></li>
                <li><a href="#" className="hover:text-emerald-400 transition-colors">UPSC</a></li>
                <li><a href="#" className="hover:text-emerald-400 transition-colors">Banking</a></li>
                <li><a href="#" className="hover:text-emerald-400 transition-colors">Railway</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold mb-4">Contact Us</h4>
              <ul className="space-y-3 text-sm text-slate-400">
                <li className="flex items-center gap-2"><Phone size={14} className="text-emerald-400" /> +91 82720 59557</li>
                <li className="flex items-center gap-2"><Mail size={14} className="text-emerald-400" /> support.mindtomaster@gmail.com</li>
                <li className="flex items-center gap-2"><MessageCircle size={14} className="text-emerald-400" /> WhatsApp Support</li>
              </ul>
            </div>
          </div>
          <div className="mt-10 pt-6 border-t border-white/5 text-center text-slate-500 text-sm flex items-center justify-center gap-1">
            <span>© 2025 Mind to Master. All rights reserved. Built with</span>
            <Heart size={14} className="text-rose-500 fill-rose-500" />
            <span>for aspiring students.</span>
          </div>
        </div>
      </footer>
    </>
  );
}
